import React, { useEffect, useState } from 'react';
import { FlameIcon } from './Icons';
function getTimeRemaining() {
  const now = new Date();
  const endOfDay = new Date(now);
  endOfDay.setHours(23, 59, 59, 999);
  const diff = endOfDay.getTime() - now.getTime();
  if (diff <= 0) return {
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function UrgencyBar() {
  const [time, setTime] = useState(getTimeRemaining);
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeRemaining());
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-50" style={{
    background: 'linear-gradient(135deg, #8b1a1a 0%, #c0392b 50%, #8b1a1a 100%)'
  }} role="banner" aria-label="Flash sale" data-id="element-372">
      <div className="max-w-5xl mx-auto px-3 sm:px-4 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-3 text-center" data-id="element-373">
        {/* Sale text */}
        <p className="text-xs sm:text-sm font-sans font-medium text-white/95 leading-snug" data-id="element-374">
          <FlameIcon className="w-3.5 h-3.5 text-yellow-400 inline-block mr-1 -mt-0.5" data-id="element-375" />
          <span className="font-bold text-yellow-300 uppercase tracking-wide" data-id="element-376">
            Flash Sale:
          </span>{' '}
          Giant Breed Awareness Month —{' '}
          <span className="font-bold text-yellow-300" data-id="element-377">85% OFF</span> The
          Longevity Blueprint!{' '}
          <span className="font-bold text-white" data-id="element-378">Only $6.39</span>
        </p>

        {/* Countdown */}
        <div className="flex items-center gap-1 font-sans tabular-nums" aria-live="polite" aria-label="Time remaining" data-id="element-379">
          <div className="bg-black/30 rounded px-1.5 py-0.5 min-w-[2rem] text-center" data-id="element-380">
            <span className="text-xs sm:text-sm font-bold text-yellow-300" data-id="element-381">
              {pad(time.hours)}
            </span>
          </div>
          <span className="text-yellow-300/60 text-xs font-bold" data-id="element-382">:</span>
          <div className="bg-black/30 rounded px-1.5 py-0.5 min-w-[2rem] text-center" data-id="element-383">
            <span className="text-xs sm:text-sm font-bold text-yellow-300" data-id="element-384">
              {pad(time.minutes)}
            </span>
          </div>
          <span className="text-yellow-300/60 text-xs font-bold" data-id="element-385">:</span>
          <div className="bg-black/30 rounded px-1.5 py-0.5 min-w-[2rem] text-center" data-id="element-386">
            <span className="text-xs sm:text-sm font-bold text-yellow-300" data-id="element-387">
              {pad(time.seconds)}
            </span>
          </div>
        </div>
      </div>
    </div>;
}